import '../modules/consultationForm';
import { searchMBA } from '../modules/exploreSection.js';


document.addEventListener("DOMContentLoaded", () => {
    searchMBA();
});